import { render, staticRenderFns } from "./BearerDetails.vue?vue&type=template&id=1c425c8f&scoped=true&"
import script from "./BearerDetails.vue?vue&type=script&lang=js&"
export * from "./BearerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c425c8f",
  null
  
)

export default component.exports